




































































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IUser } from "@/models/users";

@Component({
  components: {
    "users-provider": () =>
      import("@/components/app/admin/users/usersProvider.vue"),
    "user-list": () => import("@/components/app/admin/users/userList.vue"),
    "api-token-list": () =>
      import("@/components/app/admin/users/apiTokenList.vue")
  }
})
export default class UsersListing extends Vue {
  // Props

  @Prop({ default: null })
  public readonly active!: IUser["active"];

  @Prop({ default: null })
  public readonly revoked!: boolean;

  @Prop({ default: false })
  public readonly isApiToken!: boolean;

  // Computed

  public get manualFilters() {
    return {
      "filter[api_user]": this.isApiToken,
      ...(this.$_.isBoolean(this.active)
        ? { "filter[active]": this.active }
        : {}),
      ...(this.$_.isBoolean(this.revoked)
        ? this.revoked
          ? { "filter[api_token]": "null" }
          : { "filter[api_token|neq]": "null" }
        : {})
    };
  }
}
